var _online, _cleanup, _setup;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
// src/onlineManager.ts
import { Subscribable } from "./subscribable.js";
import { isServer } from "./utils.js";
var OnlineManager = (_online = /*#__PURE__*/new WeakMap(), _cleanup = /*#__PURE__*/new WeakMap(), _setup = /*#__PURE__*/new WeakMap(), class OnlineManager extends Subscribable {
  constructor() {
    super();
    _classPrivateFieldInitSpec(this, _online, true);
    _classPrivateFieldInitSpec(this, _cleanup, void 0);
    _classPrivateFieldInitSpec(this, _setup, void 0);
    _classPrivateFieldSet(_setup, this, onOnline => {
      if (!isServer && window.addEventListener) {
        const onlineListener = () => onOnline(true);
        const offlineListener = () => onOnline(false);
        window.addEventListener("online", onlineListener, false);
        window.addEventListener("offline", offlineListener, false);
        return () => {
          window.removeEventListener("online", onlineListener);
          window.removeEventListener("offline", offlineListener);
        };
      }
      return;
    });
  }
  onSubscribe() {
    if (!_classPrivateFieldGet(_cleanup, this)) {
      this.setEventListener(_classPrivateFieldGet(_setup, this));
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _classPrivateFieldGet2;
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_cleanup, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.call(this);
      _classPrivateFieldSet(_cleanup, this, void 0);
    }
  }
  setEventListener(setup) {
    var _classPrivateFieldGet3;
    _classPrivateFieldSet(_setup, this, setup);
    (_classPrivateFieldGet3 = _classPrivateFieldGet(_cleanup, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
    _classPrivateFieldSet(_cleanup, this, setup(this.setOnline.bind(this)));
  }
  setOnline(online) {
    const changed = _classPrivateFieldGet(_online, this) !== online;
    if (changed) {
      _classPrivateFieldSet(_online, this, online);
      this.listeners.forEach(listener => {
        listener(online);
      });
    }
  }
  isOnline() {
    return _classPrivateFieldGet(_online, this);
  }
});
var onlineManager = new OnlineManager();
export { OnlineManager, onlineManager };